/** App envs where GA4 hits are sent to collectors (local dev logs only). */
const GA_SEND_ENABLED_ENVS = new Set(['staging', 'interop', 'production'])

/**
 * True when client-side GA should call gtag (staging, interop, production).
 * Development (`pnpm dev`) logs resolved event names instead of sending.
 */
export function isGoogleAnalyticsSendEnabled(appEnv: string | undefined | null): boolean {
  return GA_SEND_ENABLED_ENVS.has((appEnv ?? '').trim())
}
